import type { ChannelShareData } from "@expert/shared-types";

import { persist } from "zustand/middleware";
import { immer } from "zustand/middleware/immer";
import { shallow } from "zustand/shallow";
import { createWithEqualityFn } from "zustand/traditional";

export type { ChannelShareData };

interface CallDetailsState {
    callDetails: ChannelShareData;
    setCallDetails: (callDetails: ChannelShareData) => void;
    resetCallDetails: () => void;
}

export const useCallDetailsStore = createWithEqualityFn<CallDetailsState>()(
    persist(
        immer((set) => ({
            callDetails: {},
            setCallDetails: (callDetails: ChannelShareData) => {
                set((state) => {
                    state.callDetails = callDetails;
                });
            },
            resetCallDetails: () => {
                set((state) => {
                    state.callDetails = {};
                });
            },
        })),
        { name: "call-details-store", skipHydration: true },
    ),
    shallow,
);
